import React, { FC } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from './editSession/assets/seances-form.module.scss';

interface Props {
    data: any;
}

const TotalTable: FC<Props> = ({ data }) => {
    if (!data) return null;
    const weeksStatArray: any = Object.values(data);
    let schedule = 0;
    //const weekNumber = 0;
    let completed = 0;

    const weekStats: any = [];
    weeksStatArray.forEach((it: any) => {
        schedule += it.schedule;

        completed += it.completed;
        weekStats.push({ ...it, schedule: it.schedule, completed: it.completed });
    });

    weekStats.push({
        weekNumber: <b>Total</b>,
        schedule: <b>{schedule.toFixed(2)}</b>,
        completed: <b>{completed.toFixed(2)}</b>,
    });

    return (
        <SimpleTable
            classNameTable={classNames(styles.tableInvoice)}
            data={weekStats}
            columns={[
                { id: 'weekNumber', label: 'Week Number', cellStyle: 'normal' },
                { id: 'schedule', label: 'Scheduled', cellStyle: 'normal' },
                { id: 'completed', label: 'Completed', cellStyle: 'normal' },
            ]}
        />
    );
};

export default TotalTable;
